import React from "react";
import { QrCodePopupPropTypes } from "./types";
import Popup from "../Popup";
import Button from "../Button";
import { X } from "react-feather";
import i18next from "i18next";
import { QRCodeSVG } from "qrcode.react";

const QrCodePopup = ({ popupOpen, setOpen, qrcode }) => {
    const onClose = () => setOpen(false);
    return (
        <Popup
            {...{
                open: popupOpen,
                isClosable: true,
                handleClose: onClose,
            }}
        >
            <div className="qrcode-popup">
                <button className="qrcode-popup__close-btn" onClick={onClose}>
                    <X />
                </button>
                <div className="qrcode-popup__qr">
                    <QRCodeSVG value={qrcode} />
                </div>
                <p className="qrcode-popup__info">
                    {i18next.t("qrcodePopup.info")}
                </p>
                <Button
                    variant="secondary"
                    label={i18next.t("qrcodePopup.close")}
                    onClick={onClose}
                />
            </div>
        </Popup>
    );
};

QrCodePopup.propTypes = QrCodePopupPropTypes;
export default QrCodePopup;
